"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classpass = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/classpass.jpg"));

var _clientPoint = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/client-point.jpg"));

var _iqCreditUnion = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/iq-credit-union.jpg"));

var _terraton = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/terraton.jpg"));

var _classpass2x = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/classpass-2x.jpg"));

var _clientPoint2x = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/client-point-2x.jpg"));

var _iqCreditUnion2x = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/iq-credit-union-2x.jpg"));

var _terraton2x = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/mon317/terraton-2x.jpg"));

var _default = [{
  screenshot: _classpass.default,
  alt: 'ClassPass',
  screenshot2X: _classpass2x.default,
  trackingId: 'classpass'
}, {
  screenshot: _clientPoint.default,
  alt: 'ClientPoint',
  screenshot2X: _clientPoint2x.default,
  trackingId: 'clientpoint'
}, {
  screenshot: _iqCreditUnion.default,
  alt: 'iQ Credit Union',
  screenshot2X: _iqCreditUnion2x.default,
  trackingId: 'iq-credit-union'
}, {
  screenshot: _terraton.default,
  alt: 'Terraton Initiative',
  screenshot2X: _terraton2x.default,
  trackingId: 'terraton-initiative'
}];
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-hub-page/Mon317CarouselData.js
// module id = 491
// module chunks = 5 6